import useSupportStore from "../../../store/supportStore";
import { formatDateT } from "../../../../../shared/utils/formatters";
import { formatData } from "../../../utils/supportFormatters";

const stepKey = "spCancellation";

const SpCancellationMapper = {
  get: () => {
    const store = useSupportStore.getState();
    return store[stepKey] || {};
  },
  set: (data) => {
    const store = useSupportStore.getState();
    store.updateStepFields(stepKey, data);

    // --- Payload update logic (mirroring spAddressMapper) ---
    const rawFormValues = {
      title: "Cancel Policy",
      "Cancel from": data.cancelFrom,
      "Cancel time": data.cancelTime?.label,
      "Reason for Cancellation": data.cancellationReason?.label,
      ...(data.cancellationReason?.value === "other" && {
        "Other Reason": data.otherReason,
      }),
      "Have you been involved in any accidents/claims since the policy started?":
        data.involved,
      ...(data.involved === "Yes" && {
        "Date of accident": data.accidentDate,
        "Accident time": data.accidentTime?.label,
        "Have you reported this to us?": data.reported,
      }),
    };
    const formValues = Object.fromEntries(
      Object.entries(rawFormValues).filter(
        ([, value]) => value !== undefined && value !== null && value !== ""
      )
    );
    const formattedData = formatData(formValues);

    store.updateField("Cancellation_Details__c", formattedData);
    store.updateField("Cancellation_Request__c", true);
    store.updateField(
      "Cancellation_Effective_From__c",
      formatDateT(data.cancellationEffectiveDateTime) || ""
    );
  },
};

export default SpCancellationMapper;
